import React from 'react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { observer as observerLite } from 'src/utils/mobx-react';
import {
    EventRowSelections,
    EventRowSelectionsName,
    EventRowSelectionsElement,
    EventRowSingleSelection,
    EventRowSingleSelectionNewVersion,
} from 'src/domains/sportsbook/webview/components/eventsList/eventRow6Pack/EventRowSelectionsGroup.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

/** Match Participant6Pack rows: Home → Away, and Over → Under for totals. */
const SIX_PACK_SELECTION_ORDER = ['H', 'A', 'O', 'U'];

const sortSixPackSelections = (selections: Array<SelectionModel>): Array<SelectionModel> => {
    return [...selections].sort((prev, next) => {
        const prevIndex = SIX_PACK_SELECTION_ORDER.indexOf(prev.templateId ?? '');
        const nextIndex = SIX_PACK_SELECTION_ORDER.indexOf(next.templateId ?? '');

        if (prevIndex === -1 && nextIndex === -1) {
            return 0;
        }
        if (prevIndex === -1) {
            return 1;
        }
        if (nextIndex === -1) {
            return -1;
        }

        return prevIndex - nextIndex;
    });
};

interface SelectionsGroupPropsType {
    market?: MarketModel;
    marketTypeName?: string;
    getSelectionNameCallback: (market: MarketModel | undefined, selection: SelectionModel) => string;
}

export const SelectionsGroup = observerLite<SelectionsGroupPropsType>('SelectionsGroup', (props) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).unifiedComponentConfig;

    const { sportsbookVariant } = configState.componentVariants;
    const { unifiedSportEventsTable } = configState;
    const { market, marketTypeName = '-', getSelectionNameCallback } = props;

    if (market === undefined) {
        return (
            <EventRowSelections variant={sportsbookVariant}>
                <EventRowSelectionsName variant={sportsbookVariant}>{marketTypeName}</EventRowSelectionsName>
            </EventRowSelections>
        );
    }

    const selections = sortSixPackSelections(market.selections);

    return (
        <EventRowSelections variant={sportsbookVariant}>
            <EventRowSelectionsName variant={sportsbookVariant}>{marketTypeName}</EventRowSelectionsName>
            {selections.map((selection) => {
                const selectionName = getSelectionNameCallback(market, selection);
                const lineLabel = selectionName === '' ? null : selectionName;

                return (
                    <EventRowSelectionsElement
                        key={selection.id2.toOldId()}
                        variant={sportsbookVariant}
                    >
                        {unifiedSportEventsTable === true ? (
                            <EventRowSingleSelectionNewVersion
                                selectionId={selection.id2}
                                sp={false}
                                lineLabel={lineLabel}
                                borderLeft={false}
                                borderRight={false}
                                borderBottom={false}
                            />
                        ) : (
                            <EventRowSingleSelection
                                participantName={selectionName === '' ? undefined : selectionName}
                                selectionId={selection.id2}
                                borderLeft={true}
                                borderRight={true}
                                borderBottom={true}
                            />
                        )}
                    </EventRowSelectionsElement>
                );
            })}
        </EventRowSelections>
    );
});
